export const appStoreLInk = {
    android: "https://play.google.com/store/apps/details?id=com.comradesol.ftgroupapp",
    ios: "https://apps.apple.com/jp/app/fcloud-%E3%82%A8%E3%83%95%E3%82%AF%E3%83%A9%E3%82%A6%E3%83%89/id1569326584",
}